import React, { CSSProperties } from "react";

import { Container } from "./styles";

interface PanelLayout {
  styles?: CSSProperties;
}

export const PanelLayout: React.FC<PanelLayout> = ({ children, ...rest }) => {
  return <Container {...rest}>{children}</Container>;
};
